

















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateUserInviteInfo} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class UpdateUserInviteInfoDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private data: any = {
    inviteUserId: undefined,
  }
  private show = false
  private isEdit = false
  private memberList: Array<any> = []



  public async open(data: any) {
    this.show = true
    this.data.userId = data.id;
    this.data.inviteUserId = data.inviteUserId
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    inviteUserId: [this.requiredRule],
  }


  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        const result = await UpdateUserInviteInfo(this.data)
        if(result){
          this.$message.success("修改成功")
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
